/**
 * Earnings Badge - Shows upcoming earnings countdown
 *
 * Built on top of CountdownBadge for consistent styling.
 */
import { CountdownBadge, CalendarIcon } from './CountdownBadge'

interface EarningsBadgeProps {
  daysUntil: number
  reportDate?: string
}

export function EarningsBadge({ daysUntil, reportDate }: EarningsBadgeProps) {
  // Format date for tooltip
  const formattedDate = reportDate
    ? new Date(reportDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : undefined

  const title = formattedDate
    ? `Earnings: ${formattedDate}`
    : `Earnings in ${daysUntil} days`

  return (
    <CountdownBadge
      days={daysUntil}
      title={title}
      size="sm"
      icon={<CalendarIcon className="w-3 h-3" />}
    />
  )
}
